import api from './api';

const getMapaByID = async payload => {
  const response = await api.get(`mapa?id=${payload}`);
  return response.data;
};

export default getMapaByID;
